import usePagePermission from "app/hooks/usePagePermission";
import Tooltip from "rc-tooltip";
import { Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { FaPlus } from "react-icons/fa";

const AppPopOver = ({
  target,
  setTarget,
  setIsShow,
  isShow,
  id,
  handleSubmit,
  ParentMenu,
}) => {
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();
  //console.log({ canView, canAdd, canEdit, canDelete });

  return (
    <OverlayTrigger
      trigger="click"
      placement="auto"
      show={isShow}
      overlay={
        <Popover id="popover-basic" style={{ width: 300, zIndex: 500 }}>
          <Popover.Header as="h3">Add Menu</Popover.Header>
          <Popover.Body>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Menu name"
                className="my-2 form-control"
              />
              <input
                type="text"
                name="icon"
                placeholder="Menu icon"
                className="my-2 form-control"
              />
              <input
                type="text"
                name="path"
                placeholder="Path"
                className="mt-2 form-control mb-2"
              />
              <input
                type="text"
                name="description"
                placeholder="Description"
                className="mt-2 form-control mb-2"
              />
              <input type="hidden" value={id} name="id" />

              <div className="d-flex justify-content-center">
                <div className="m-auto">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger mx-1"
                    onClick={() => setIsShow(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-sm btn-outline-primary"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </Popover.Body>
        </Popover>
      }
    >
      {ParentMenu ? (
        canAdd ? (
          <button
            className="btn btn-outline-primary btn-xs ms-1"
            type="button"
            onClick={(e) => {
              setTarget(e.target);
              setIsShow(true);
            }}
          >
            + New Menu
          </button>
        ) : (
          <></>
        )
      ) : canAdd ? (
        <Tooltip placement="top" overlay={<span>Add Child Menu</span>}>
          <button
            className="btn btn-link btn-sm"
            type="button"
            onClick={(e) => {
              setTarget(e.target);
              setIsShow(true);
            }}
          >
            <FaPlus />
          </button>
        </Tooltip>
      ) : (
        <></>
      )}
    </OverlayTrigger>
  );
};
export default AppPopOver;
